// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"51be5127","455":"35f064ee","977":"1ea53d33"}[chunkId] + ".chunk.js";
};